import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="select-reveal"
export default class extends Controller {
  static targets = ['select', 'container']

  connect() {
    this.toggle()
  }

  change() {
    this.toggle()
  }

  toggle() {
    const selectedValue = this.selectTarget.value

    this.containerTargets.forEach(container => {
      const containerValues = container.dataset.selectRevealValue.split(' ')
      
      if (containerValues.includes(selectedValue)) {
        this.show(container)
      } 
      else {
        this.hide(container)
      }
    })
  }

  show(container) {
    container.classList.remove('hide')
  }

  hide(container) {
    container.classList.add('hide')
  }
}
